import React from "react";
import "../styles/ActionButton.css";
import { ArrowUpRight } from "lucide-react";
import ScrambleText from "./ScrambleText";

export const ActionButton1 = (props) => {
  const label = props?.data;
  const showIcon = props?.showIcon !== false;
  const onClick = props?.onClick;
  const type = props?.type || "button";
  const wrapperClassName = props?.wrapperClassName || "";
  const buttonClassName = props?.buttonClassName || "";
  const wrapperStyle = props?.wrapperStyle;
  const buttonStyle = props?.buttonStyle;
  const ariaPressed = props?.ariaPressed;

  return (
    <div className={`button-outer ${wrapperClassName}`.trim()} style={wrapperStyle}>
      <span className="corner top-left" />
      <span className="corner top-right" />
      <span className="corner bottom-left" />
      <span className="corner bottom-right" />
      <button
        type={type}
        onClick={onClick}
        className={`action-button ${buttonClassName}`.trim()}
        style={buttonStyle}
        aria-pressed={ariaPressed}
      >
        <span className="text">
          <ScrambleText text={label} />
        </span>
        {showIcon && <ArrowUpRight className="icon" size={16} strokeWidth={2} />}
      </button>
    </div>
  );
};
export default ActionButton1;
